































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";

export default Vue.extend({
  name: "MusicController",
  components: {
    BaseSimpleSlider,
    BaseButton,
    BaseInput,
    BaseCheckbox,
  },
  data: function () {
    return {};
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    clickCustomTime() {
      //if (this.previewItem.currentVariation.music.isCustomTime) {
      this.clearMusicTime();
      //}
    },
    clickExtendMusic() {
      this.changeCheckedItems(false, false, false, false, true);
    },
    clearMusicTime() {
      this.previewItem.currentVariation.music.startTime =
        this.previewItem.currentVariation.cut.startTime;
      this.changeCheckedItems();
    },
    clearMusic() {
      this.previewItem.currentVariation.music.file = null;
      this.previewItem.currentVariation.music.libraryType = null;
      this.changeCheckedItems(false, false, true);
    },
    openMusicLibraryWindow() {
      this.$store.commit("showMusicLibraryWindow", true);
    },
    changeCheckedItems(
      isVolume,
      isMusicVolume,
      isFile,
      isEndCardVolume,
      isExtendMusic
    ) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          if (isVolume) {
            v.volume = this.previewItem.currentVariation.volume;
          }
          if (isMusicVolume) {
            v.music.volume = this.previewItem.currentVariation.music.volume;
          }
          if (isEndCardVolume) {
            v.endCard.volume = this.previewItem.currentVariation.endCard.volume;
          }
          if (isExtendMusic) {
            v.music.isExtendToEndCard =
              this.previewItem.currentVariation.music.isExtendToEndCard;
          }
          if (isFile) {
            v.music.file = this.previewItem.currentVariation.music.file;
          }
          v.checkAndUpdateMusicTime();
        });
      });
    },
    isVariationMusicCanMultiselectEdit(variation) {
      if (!variation.checked) {
        return true;
      }
      return this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked && v !== variation)
        .every((v) => v.music.file);
    },
  },
});
